import '../css/app.css';
import './bootstrap';
import './i18n';

// Pusher is configured via bootstrap.ts with Reverb instead


// getfade uses the light Linear-inspired theme (white surfaces, near-black text).
// Force `colorScheme: light` to prevent OS dark-mode from swapping native controls.
if (typeof document !== 'undefined') {
    document.documentElement.classList.remove('dark');
    document.documentElement.style.colorScheme = 'light';
}

import { createInertiaApp } from '@inertiajs/react';
import { resolvePageComponent } from 'laravel-vite-plugin/inertia-helpers';
import { createRoot, hydrateRoot } from 'react-dom/client';
import { AppWrapper } from './app-wrapper';

const appName = import.meta.env.VITE_APP_NAME || 'Laravel';

createInertiaApp({
    title: (title) => `${title} - ${appName}`,
    resolve: (name) =>
        resolvePageComponent(
            `./pages/${name}.tsx`,
            import.meta.glob('./pages/**/*.tsx'),
        ),
    setup({ el, App, props }) {
        const initialCurrency = ((props as any).auth?.company?.currency || 'EUR') as any;
        const userId = (props as any).auth?.user?.id;

        if (import.meta.env.SSR) {
            hydrateRoot(el, <AppWrapper initialCurrency={initialCurrency} userId={userId}><App {...props} /></AppWrapper>);
            return;
        }

        createRoot(el).render(<AppWrapper initialCurrency={initialCurrency} userId={userId}><App {...props} /></AppWrapper>);
    },
    progress: {
        color: '#4B5563',
    },
});
